export default {

  months:{ 'en' : ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dece"],
           'fr' : ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"] } ,
  days: { 'en' : ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          'fr' : ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"]} ,
  humanDate(sqlDate) {
    if(sqlDate == "0000-00-00" || sqlDate == null) {
      return "N/A";
    }
    const t = new Date(sqlDate);
    if(t instanceof Date && !isNaN(t)) {
      const result = t.toLocaleDateString("en-GB", { // you can use undefined as first argument
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      
      return result;
    } else {
      return false
    }
  },
  shortDate(sqlDate) {
    if (sqlDate == "0000-00-00" || sqlDate == null) {
      return "N/A";
    }
    const t = new Date(sqlDate);
    if (t instanceof Date && !isNaN(t)) {
      const result = t.toLocaleDateString("en-GB", { // you can use undefined as first argument
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      return result;
    } else {
      return false
    }
  },
  humanDateTime(sqlDateTime) {
    if(sqlDateTime == "0000-00-00 00:00:00" || sqlDateTime == null) {
      return "N/A";
    }
    const t = new Date(sqlDateTime);
    if(t instanceof Date && !isNaN(t)) {
      const result = t.toLocaleDateString("en-GB", { // you can use undefined as first argument
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      return result + ' ' + t.getHours() + ':' + ('0' + t.getMinutes()).substr(-2);
    } else {
      return false;
    }
    
  },
  humanMonth(sqlDate) {
    if(sqlDate == "0000-00-00" || sqlDate == null) {
      return "N/A";
    }
    const t = new Date(sqlDate);
    
    return this.months.fr[t.getMonth()] + ' ' + t.getFullYear();
  },
  humanTimeFromSeconds(seconds) {
    if(seconds <= 0) {
      return 'Now!'
    }
    function numberEnding(number) {
      return (number > 1) ? 's' : '';
    }

    
    var years = Math.floor(seconds / 31536000);
    if (years) {
      return years + ' year' + numberEnding(years);
    }
    var days = Math.floor((seconds %= 31536000) / 86400);
    if (days) {
      return days + ' day' + numberEnding(days);
    }
    var hours = Math.floor((seconds %= 86400) / 3600);
    if (hours) {
      return hours + ' hour' + numberEnding(hours);
    }
    var minutes = Math.floor((seconds %= 3600) / 60);
    if (minutes) {
      return minutes + ' minute' + numberEnding(minutes);
    }
    var secs = seconds % 60;
    if (secs) {
      return seconds + ' second' + numberEnding(secs);
    }
    return 'less than a second'; //'just now' //or other string you like;
  },
  toMysql(date) {
    function pad2(number) {
      if ( number < 10 ) {
        return '0' + number;
      }
      return number;
    }
    let dt = date.toDate();
    let dtstring = dt.getFullYear()
    + '-' + pad2(dt.getMonth()+1)
    + '-' + pad2(dt.getDate());
    return dtstring;
  }
}